import React from "react";
import { Box, Typography, Stack, FormHelperText } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { Dropdown } from "../HelperFunctions/PayrollDropdown";


// Reusable autocomplete row
export const FormAutocompleteRow = ({
  label,
  value,
  displayValue,
  importedValue,
  options = [],
  onChange,
  helperText,
  disabled = false,
}) => {
  const normalizedOptions = options.map((opt) => {
    if (typeof opt === "object" && opt !== null) {
      return opt;
    }
    return { label: opt, value: opt };
  });

  const selectedOption =
    normalizedOptions.find((opt) => opt.value === value) ||
    normalizedOptions.find((opt) => opt.value === (value ?? "")) ||
    normalizedOptions.find((opt) => opt.value === "") ||
    null;
  const isImportedNameEmpty = !importedValue || String(importedValue).trim() === "" || String(importedValue).toLowerCase() === "null" || String(importedValue).toLowerCase() === "undefined";
  const isType1 = isImportedNameEmpty || value?.importPayrollType === 1 || value?.isAddPayRoll;

  return (
    <Stack direction="row" spacing={0.5} alignItems="center" justifyContent={"space-between"}>
      <Typography
        fontSize={"0.7rem"}
        fontWeight={450}
        title={`${label}${importedValue ? ` (${importedValue})` : ""}`}
        sx={{
          minWidth: 80,
          overflow: "hidden",
          textOverflow: "ellipsis",
          pb: label === "Name" &&
            value?.isAddPayRoll === false ? 2 : 0,
        }}
        // noWrap
      >
        {label}
        {importedValue ? <span style={{ fontSize: "10px" }}>{` (${importedValue})`}</span> : ""}
        {": "}
        {label === "Name" && !isType1 && value?.importPayrollType === 2 && 
            <span title={displayValue || value}>{displayValue || value}</span>}
      </Typography>
      <Box sx={{minWidth:160, width: 160 }}>
        <Dropdown
          label=""
          name={label}
          options={normalizedOptions}
          getOptionLabel={(option) => option.label || ""}
          value={selectedOption}
          onChange={(name, newValue) => {
            onChange({ target: { value: newValue?.value || "" } }, newValue || null);
          }}
          isEqual={(option, val) => option.value === val.value}
          disabled={disabled}
          renderOption={(props, option, { selected }) => {
            const { key, ...restProps } = props;
            const label = option?.label || "";
            return (
              <li key={key} {...restProps} title={label}>
                <Box display="flex" alignItems="center" width="100%" minWidth={0}>
                  <Typography
                    fontSize={11}
                    title={label}
                    sx={{
                      flex: 1,
                      minWidth: 0,
                      whiteSpace: "nowrap",
                      color:
                        option?.value === "ADD_NEW" || option?.value === "ADD_OTHER"
                          ? "#d32f2f"
                          : "inherit",
                      fontWeight:
                        option?.value === "ADD_NEW" || option?.value === "ADD_OTHER"
                          ? 600
                          : 400,
                    }}
                  >
                    <span title={label}>{label}</span>
                  </Typography>
                  {option.type && (
                    <Typography
                      fontSize={11}
                      ml={1}
                      title={option.type}
                      sx={{
                        whiteSpace: "nowrap",
                        flexShrink: 0,
                        fontWeight: 600,
                        color: selected ? "white" : "#E0E0E0",
                      }}
                    >
                      <span title={option.type}>{option.type}</span>
                    </Typography>
                  )}
                </Box>
              </li>
            );
          }}
          popperSx={{ width: "fit-content", minWidth: 120 }}
          sx={{
            "& .MuiFilledInput-root": {
              height: 25,
              fontSize: "12px",
              bgcolor: "white",
              padding: "0 25px 0 0 !important",
              "&.Mui-disabled": {
                  backgroundColor: "#E0E0E0 !important",
              }
            },
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000 !important",
              color: "#000 !important",
            },
            "& .MuiFilledInput-input": {              padding: "4px 30px 4px 4px !important",
            }
          }}
        />
        {helperText && (
          <FormHelperText
            sx={{
              fontSize: "0.60rem",
              lineHeight: 1,
              minHeight: "1em",
              display: "flex",
              alignItems: "flex-start",
            }}
          >
            <InfoIcon sx={{ fontSize: "0.9rem", color: "#a2ddf9" }} />
            {helperText}
          </FormHelperText>
        )}
      </Box>
    </Stack>
  );
};


// Reusable form row
export const FormRow = ({ label, children, value, width = 160, importedValue }) => {
  const isImportedNameEmpty = !importedValue || String(importedValue).trim() === "" || String(importedValue).toLowerCase() === "null" || String(importedValue).toLowerCase() === "undefined";
  const isType1 = isImportedNameEmpty || value?.importPayrollType === 1 || value?.isAddPayRoll;

  return (
    <Stack direction="row" spacing={1} alignItems="center" justifyContent={"space-between"}>
      <Typography noWrap fontSize={"0.7rem"} fontWeight={450}
        title={`${label}${importedValue ? ` (${importedValue})` : ""}`}
        sx={{
          minWidth: 80,
          fontWeight: 450,
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {label}
        {importedValue ? <span style={{ fontSize: "10px" }}>{` (${importedValue})`}</span> : ""}
        {": "}
        {label === "Name" && !isType1 && value?.importPayrollType === 2 && 
              <span title={value}>{ value}</span>}
      </Typography>

      {/* Wrap children in a consistent sized box */}
      <Box
        sx={{
          minWidth: width,
          width: width,
          "& .MuiOutlinedInput-root": {
            height: 25,
            fontSize: "12px",
            bgcolor: "white",
          },
          "& .MuiOutlinedInput-input": {
            padding: "0 8px",
          },
        }}
      >
        {children}
      </Box>
    </Stack>
  );
};